import React from 'react';
import ReactDOM from 'react-dom/client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { App } from './App';
import { TONCONNECT_MANIFEST_URL } from './lib/ton-connect';
import { initTelegramAnalytics } from './lib/telegramAnalytics';
import './styles/theme.css';

initTelegramAnalytics();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <TonConnectUIProvider
      manifestUrl={TONCONNECT_MANIFEST_URL}
      // After approving в @wallet/Tonkeeper юзер возвращается обратно в Mini App
      actionsConfiguration={{
        twaReturnUrl: 'https://t.me' as `${string}://${string}`,
      }}
    >
      <App />
    </TonConnectUIProvider>
  </React.StrictMode>
);

requestAnimationFrame(() => {
  document.getElementById('app-loading')?.remove();
});
